(() => {
  const initialise = (scope) => {
    scope.querySelectorAll('[data-home-hero]').forEach((hero) => {
      if (hero.dataset.initialised) return;
      hero.dataset.initialised = 'true';
      const host = hero.querySelector('.home-video-host');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let video;
      let userPaused = false;
      const pauseButton = hero.querySelector('[data-home-pause]');
      const typer = hero.querySelector('[data-home-typer]');
      const phrases = typer?.dataset.phrases.split('|').filter(Boolean) || [];
      let phraseIndex = 0, character = 0, deleting = false, typingTimer;
      const stopTyping = () => { clearTimeout(typingTimer); typingTimer = undefined; };
      const tick = () => {
        if (!typer || !phrases.length) return;
        const phrase = phrases[phraseIndex];
        character += deleting ? -1 : 1;
        typer.textContent = phrase.slice(0, character);
        let delay = deleting ? 60 : 90;
        if (!deleting && character >= phrase.length) { deleting = true; delay = 1600; }
        else if (deleting && character <= 0) { deleting = false; phraseIndex = (phraseIndex + 1) % phrases.length; delay = 400; }
        typingTimer = setTimeout(tick, delay);
      };
      let visible = false;
      const update = () => {
        if (userPaused || !visible || document.hidden || motion.matches || !hero.isConnected) {
          stopTyping();
          if (motion.matches && typer) typer.textContent = phrases[0] || '';
        } else if (typer && !typingTimer) {
          typingTimer = setTimeout(tick, 400);
        }
        if (userPaused || !visible || document.hidden || motion.matches || !hero.isConnected) {
          video?.pause();
          return;
        }
        if (!video) {
          const mobile = matchMedia('(max-width: 749px)').matches;
          const source = hero.querySelector(mobile ? '[data-home-mobile]' : '[data-home-desktop]');
          const fallback = hero.querySelector('[data-home-desktop]');
          const template = source?.content.querySelector('video') ? source : fallback;
          if (!host || !template?.content.querySelector('video')) return;
          host.append(template.content.cloneNode(true));
          video = host.querySelector('video');
          video.muted = true;
          video.defaultMuted = true;
          video.loop = true;
          video.autoplay = true;
          video.playsInline = true;
          video.controls = false;
          if (pauseButton) pauseButton.hidden = false;
          video.addEventListener('error', () => { video.hidden = true; });
        }
        if (video.paused) video.play().catch(() => {  });
      };
      pauseButton?.addEventListener('click', () => {
        userPaused = !userPaused;
        pauseButton.setAttribute('aria-pressed', String(userPaused));
        pauseButton.textContent = userPaused ? pauseButton.dataset.playLabel : pauseButton.dataset.pauseLabel;
        update();
      });
      const observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; update(); });
      observer.observe(hero);
      document.addEventListener('visibilitychange', update);
      motion.addEventListener('change', update);
      const cleanup = (event) => {
        if (!event.target.contains(hero)) return;
        video?.pause();
        stopTyping();
        observer.disconnect();
        document.removeEventListener('visibilitychange', update);
        motion.removeEventListener('change', update);
        document.removeEventListener('shopify:section:unload', cleanup);
      };
      document.addEventListener('shopify:section:unload', cleanup);
    });
  };
  initialise(document);
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();